// Points 4/23 — instant-cache-then-background-refresh helper.
//
// For DISPLAY-ONLY data (header labels, names, DPs, chat history, group
// details, settings-type data): show the last-known value from localStorage
// instantly, then silently refetch and overwrite once the live response
// lands. Never use this for money/balance/transaction status, deposit/
// withdraw status, coin balance, mark-as-paid confirmation, any live
// financial number, or real-time actions (new messages, live online status,
// system-generated messages) — those must always come straight from the
// server per point 4/23's explicit exclusion list.
//
// Usage:
//   const cached = readInstantCache('room_info', roomId);
//   if (cached) setCustomer(cached);           // paint instantly
//   const fresh = await axios.get(...);
//   setCustomer(fresh.data);
//   writeInstantCache('room_info', roomId, fresh.data);   // refresh cache

const CACHE_PREFIX = 'dws_instant_cache_';

const cacheKey = (namespace, id) => `${CACHE_PREFIX}${namespace}_${id}`;

export const readInstantCache = (namespace, id) => {
  if (!id) return null;
  try {
    const raw = localStorage.getItem(cacheKey(namespace, id));
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

export const writeInstantCache = (namespace, id, value) => {
  if (!id) return;
  try {
    localStorage.setItem(cacheKey(namespace, id), JSON.stringify(value));
  } catch (_) {
    // Storage full/unavailable — silently skip. This is a convenience
    // cache, not a source of truth, so a failed write is never fatal.
  }
};
